import { useAddress, useContract } from '@thirdweb-dev/react';
import { useAsync } from 'react-use';
import { bigNumberToDecimal } from '@app/helpers/format';
import { useConfig } from '@app/config';

export function useDistributedTokenDetails(index: number) {
  const address = useAddress();
  const config = useConfig();
  const { contract } = useContract(config?.CONTRACTS.DIVIDENDS);

  const { value, loading } = useAsync(async () => {
    if (!contract || !address) {
      return;
    }

    const distributedTokenAddress = await contract.call('distributedToken', [
      index
    ]);

    const dividendsInfo = await contract.call('dividendsInfo', [
      distributedTokenAddress
    ]);

    return {
      currentDistributionAmount: bigNumberToDecimal(dividendsInfo[0], 18),
      currentCycleDistributedAmount: bigNumberToDecimal(dividendsInfo[1], 18),
      pendingAmount: bigNumberToDecimal(dividendsInfo[2], 18),
      distributedAmount: bigNumberToDecimal(dividendsInfo[3], 18),
      accDividendsperShare: bigNumberToDecimal(dividendsInfo[4], 18),
      lastUpdateTime: dividendsInfo[5],
      cycleDividendsPercent: dividendsInfo[6],
      distributionDisabled: dividendsInfo[7],
      distributedTokenAddress
    };
  }, [contract, address]);

  return {
    isLoading: loading,
    currentDistributionAmount: value?.currentDistributionAmount,
    currentCycleDistributedAmount: value?.currentCycleDistributedAmount,
    pendingAmount: value?.pendingAmount,
    distributedAmount: value?.distributedAmount,
    accDividendsperShare: value?.accDividendsperShare,
    lastUpdateTime: value?.lastUpdateTime,
    cycleDividendsPercent: value?.cycleDividendsPercent,
    distributionDisabled: value?.distributionDisabled,
    distributedTokenAddress: value?.distributedTokenAddress
  };
}
